






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AppCenter extends Vue {
  link = 'https://vip.wps.cn/static/spa/vip-service-center/index.html'
  action = 'getAppCenterHeight'

  mounted () {
    const el: any = this.$refs.appCenter
    window.addEventListener('message', (event) => {
      const reveiveData = event.data
      if (reveiveData.action === this.action) {
        el.height = reveiveData.data
      }
    }, false)
  }

  loadIframe () {
    const el: any = this.$refs.appCenter
    el.contentWindow.postMessage({ action: this.action }, '*')
  }
}
